
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import MainLayout from "@/components/layout/MainLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { SubscriptionManager } from '@/components/subscription/SubscriptionManager';
import { useAuthSession } from '@/hooks/useAuthSession';
import { Navigate } from 'react-router-dom';
import { SecuritySettings } from '@/components/security/SecuritySettings';
import { useIsMobile } from '@/hooks/use-mobile';
import { ScrollArea } from "@/components/ui/scroll-area";

export default function Settings() {
  const { isAuthenticated, isLoading } = useAuthSession();
  const { isMobile } = useIsMobile();

  // Redirect to auth page if not authenticated
  if (!isLoading && !isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }
  
  return (
    <MainLayout>
      <div className="container max-w-6xl mx-auto px-2 sm:px-4 py-4 sm:py-8 w-full">
        <h1 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">Settings</h1>
        
        <Tabs defaultValue="subscription" className="w-full">
          {isMobile ? (
            <ScrollArea className="w-full">
              <div className="min-w-[400px] pb-2">
                <TabsList className="mb-4 w-full flex">
                  <TabsTrigger value="subscription" className="flex-1">Subscription</TabsTrigger>
                  <TabsTrigger value="account" className="flex-1">Account</TabsTrigger>
                  <TabsTrigger value="preferences" className="flex-1">Preferences</TabsTrigger>
                  <TabsTrigger value="security" className="flex-1">Security</TabsTrigger>
                </TabsList>
              </div>
            </ScrollArea>
          ) : (
            <TabsList className="mb-6">
              <TabsTrigger value="subscription">Subscription</TabsTrigger>
              <TabsTrigger value="account">Account</TabsTrigger>
              <TabsTrigger value="preferences">Preferences</TabsTrigger>
              <TabsTrigger value="security">Security</TabsTrigger>
            </TabsList>
          )}
          
          <TabsContent value="subscription">
            <div className={`space-y-4 sm:space-y-6 ${isMobile ? 'px-0' : 'px-4'}`}>
              <SubscriptionManager />
            </div>
          </TabsContent>
          
          <TabsContent value="account">
            <Card className={isMobile ? 'mx-0' : 'mx-4'}>
              <CardHeader>
                <CardTitle>Account Settings</CardTitle>
                <CardDescription>
                  Manage your account details and security settings
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">Account settings coming soon...</p>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="preferences">
            <Card className={isMobile ? 'mx-0' : 'mx-4'}>
              <CardHeader>
                <CardTitle>Preferences</CardTitle>
                <CardDescription>
                  Customize your learning experience
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">Preference settings coming soon...</p>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="security" className={isMobile ? 'px-0' : 'px-4'}>
            <SecuritySettings />
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}
